export class ModelDataChangeFilterData {
    type?: string;
    values?: any[];
}
